import React from 'react'
import { Level } from '../layouts/Level'
import classNames from 'classnames'
import { isMobile } from '../../../services/utils'

const ImageListItem = ({
  imageURL,
  imageAlt,
  children,
  toolbar,
  getImageRef,
}) => (
  <div className="box">
    <div className="columns">
      <div className="column">
        <Level className="is-mobile is-hidden-desktop">{toolbar}</Level>
        <figure className={classNames('image', { 'is-320x240': !isMobile() })}>
          {imageURL && <img src={imageURL} alt={imageAlt} ref={getImageRef} />}
        </figure>
      </div>
      <div className="column">
        <Level className="is-mobile is-hidden-touch">{toolbar}</Level>
        <div className="content">{children}</div>
      </div>
    </div>
  </div>
)

export default ImageListItem



// WEBPACK FOOTER //
// ./src/components/views/listview/ImageListItem.js